import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { LocationData } from "src/app/_models/location/LocationData";
import { LocationDataDto } from "src/app/_models/location/LocationDTO";

type LocationDataMap = { id_location: number; data: LocationData[] };

export const SignalLocationDataStore = new SignalStoreBuilder<LocationDataMap>(
  (entry) => entry.id_location,
  (json) => {
    const id = json["id_location"] as number;
    const data = (json["data"] as unknown[]).map((d) =>
      LocationData.fromDto(LocationDataDto.fromJson(d)),
    );
    return { id_location: id, data };
  },
)
  .withMethod("loadAllLatest", (_store, http, { upsert }) => async () => {
    const response = await http.get("location/data", { hideLoader: true });
    if (!response) return;
    for (const item of response as any as {
      id_location: number;
      data: unknown;
    }[]) {
      if (!item.data) continue;
      const incoming = LocationData.fromDto(LocationDataDto.fromJson(item.data));
      const existing = _store.entityMap()[item.id_location]?.data ?? [];
      upsert({
        id_location: item.id_location,
        data: [incoming, ...existing.filter(d => d.created_at.getTime() !== incoming.created_at.getTime())],
      });
    }
  })
  .withMethod(
    "loadData",
    (_store, http, { upsert }) =>
      async (id_location: number, limit: number = 120) => {
        const response = await http.get(
          `location/${id_location}/data?limit=${limit}`,
          { hideLoader: true },
        );
        if (!response) return;
        const data = (response["data"] as unknown[]).map((d) =>
          LocationData.fromDto(LocationDataDto.fromJson(d)),
        );
        upsert({ id_location, data });
      },
  )
  .withMethod(
    "loadLatest",
    (_store, http, { upsert }) =>
      async (id_location: number) => {
        const response = await http.get(
          `location/${id_location}/data?limit=1`,
          { hideLoader: true },
        );
        if (!response) return;
        const incoming = (response["data"] as unknown[]).map((d) =>
          LocationData.fromDto(LocationDataDto.fromJson(d)),
        );
        const existing = _store.entityMap()[id_location]?.data ?? [];
        const merged = [
          ...incoming,
          ...existing.filter(e => !incoming.some(i => i.created_at.getTime() === e.created_at.getTime())),
        ];
        upsert({ id_location, data: merged });
      },
  )
  .withAutoRefresh((store) => store.loadAllLatest())
  .providedInRoot()
  .build();
